import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Ligne à cocher de « Mes tâches » (maquettes 02 et 05), pour un geste comme
 * pour une plante : deux boutons côte à côte, le rond coche, le reste de la
 * ligne (le contenu projeté) ouvre. Le rond est la coche ronde de l'app
 * (`vw-checkbox`), dans une cible de 44 px.
 *
 * La ligne ne retient rien : l'écran dit si elle est cochée et enregistre.
 */
@Component({
  selector: 'vw-check-row',
  standalone: true,
  template: `
    <div class="flex min-h-14 items-center pl-1.5" [class.bg-vw-bg]="checked">
      <button type="button" role="checkbox" data-test="row-check" [attr.aria-checked]="checked" [attr.aria-label]="label"
        (click)="check.emit()" class="flex h-target w-target shrink-0 items-center justify-center">
        <span class="vw-checkbox" [class.is-checked]="checked" aria-hidden="true"></span>
      </button>
      <button type="button" data-test="row-open" (click)="open.emit()"
        class="flex min-h-14 min-w-0 flex-1 items-center gap-3 py-1.5 pl-0.5 pr-4 text-left active:bg-vw-surface-sunk">
        <ng-content></ng-content>
      </button>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class CheckRowComponent {
  @Input() checked = false;
  /** Nom du rond pour le lecteur d'écran, déjà traduit. */
  @Input() label = '';
  @Output() check = new EventEmitter<void>();
  @Output() open = new EventEmitter<void>();
}
